import { UserRoleEnum, ServiceShortEnum, ServiceTypeEnum } from 'utils/enums';
import invert from 'lodash/invert';

export const consultPaths = Object.entries(ServiceShortEnum).reduce(
  (res, [service, path]) => ({ ...res, [service]: path }),
  {},
);

export const path2Service = invert(consultPaths);

const Paths = {
  Macros: 'macros',
  MyFacility: 'my-facility',
  ConsultRequest: 'consult-request',
  Messages: 'messages',
  Schedule: 'schedule',
  Admin: 'admin',
  Profile: 'profile',
  Restricted: 'restricted',
  ClinicalDecisionSupport: 'clinical-decision-support',
  Analytics: 'analytics',
  ...consultPaths,
};

export default Paths;

export const RoutesForRoleEnum = {
  [UserRoleEnum.NEURO]: {
    priority: 1,
    routes: [Paths[ServiceTypeEnum.NEURO], Paths.Macros, Paths.ConsultRequest, Paths.ClinicalDecisionSupport],
  },
  [UserRoleEnum.TELE_NEURO]: {
    priority: 2,
    routes: [
      Paths[ServiceTypeEnum.TELE_NEURO],
      Paths.Macros,
      Paths.ConsultRequest,
      Paths.ClinicalDecisionSupport,
    ],
  },
  [UserRoleEnum.CLINIC]: {
    priority: 3,
    routes: [Paths[ServiceTypeEnum.CLINIC], Paths.Macros, Paths.ClinicalDecisionSupport],
  },
  [UserRoleEnum.EEG]: {
    priority: 4,
    routes: [Paths[ServiceTypeEnum.EEG], Paths.Macros, Paths.ConsultRequest, Paths.ClinicalDecisionSupport],
  },
  [UserRoleEnum.PEDS_EEG]: {
    priority: 5,
    routes: [
      Paths[ServiceTypeEnum.PEDS_EEG],
      Paths.Macros,
      Paths.ConsultRequest,
      Paths.ClinicalDecisionSupport,
    ],
  },
  [UserRoleEnum.ADMINISTRATOR]: {
    priority: 6,
    routes: [Paths.Admin],
  },
  [UserRoleEnum.CUSTOMER]: {
    priority: 7,
    routes: [Paths.MyFacility],
  },
  [UserRoleEnum.ANALYTICS]: {
    priority: 8,
    routes: [Paths.Analytics],
  },
};
